import { skuDetails } from './sku';

type Params = {};
export type InventoryCountProps = {};

export type ItemType = {
  sku: string;
  quantity: number;
  sealedQuantity?: number;
  skuDetails?: skuDetails;
};

export type InventoryCount = {
  _id: string;
  site: string;
  washHub: string;
  beginningDate: string;
  countDate: string;
  countNumber: number;
  status: number;
  sealedPackages: Array<ItemType>;
  openItems: Array<ItemType>;
  openCases: Array<ItemType>;
  createdAt: string;
  updatedAt: string;
  notes?: string;
  previousInventoryCount?: unknown;
  pendingPickup?: number;
  harvestCount: number;
  reports?: Array<{
    sku: string;
    beg: number;
    del: number;
    ret: number;
    unu: number;
    end: number;
    lost: number;
  }>;
  isArchived?: boolean;
};

export enum InventoryCountStatus {
  SCHEDULED = 0,
  COUNTS_ENTERED = 1,
  PENDING_PICKUP = 2,
  READY_FOR_REPORT = 3,
  DONE = 4,
}

export enum InventoryReportTypeEnum {
  NO_INVENTORY = 0,
  MONTHLY = 1,
  BEGINNING = 2,
  ENDING = 3,
}

export type InitiateHarvestSummaryResponse = {
  beginning: null | Date;
  ending: null | Date;
  list: Array<InventoryCount>;
};
